// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2Aeqz","col":"Table_col__1uqJE","fulfillmentStatus":"Table_fulfillmentStatus__1FHY1","emailCol":"Table_emailCol__39DSQ"};